/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairhumidity2Inputs */



/**
* | output |
* | --- |
* | "Supply air humidity" |
*
* @param {Ahu_History_Key_Supplyairhumidity2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairhumidity2 = /** @type {((inputs?: Ahu_History_Key_Supplyairhumidity2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairhumidity2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air humidity")
	return /** @type {LocalizedString} */ ("Humidité air soufflé")
});
export { ahu_history_key_supplyairhumidity2 as "ahu_history_key_supplyAirHumidity" }